// import React from 'react';
// function FAQS() {
//   return (
//     <section className="faqs section-padding position-re">
//       <div className="container">
//         <div className="row justify-content-between">
//           <div className="col-lg-4">
//             <div className="sec-head md-mb80">
//               <h6 className="sub-title main-color mb-15">FAQS</h6>
//               <h2>
//                 Frequently <br /> asked questions
//               </h2>
//             </div>
//           </div>
//           <div className="col-lg-6">
//             <div className="list-serv">
//               <div className="accordion bord">
//                 <div className="item mb-15 wow fadeInUp" data-wow-delay=".1s">
//                   <div className="title">
//                     <h6>Designing Content With AI Power</h6>
//                     <span className="ico ti-plus"></span>
//                   </div>
//                   <div className="accordion-info">
//                     <p className="">
//                       Taken possession of my entire soul, like these sweet
//                       mornings of spring which i enjoy with my whole.
//                     </p>
//                   </div>
//                 </div>

//                 <div
//                   className="item active mb-15 wow fadeInUp"
//                   data-wow-delay=".3s"
//                 >
//                   <div className="title">
//                     <h6>Talented, Professional & Expert Team</h6>
//                     <span className="ico ti-plus"></span>
//                   </div>
//                   <div className="accordion-info">
//                     <p className="mb-30">
//                       Taken possession of my entire soul, like these sweet
//                       mornings of spring which i enjoy with my whole.
//                     </p>
//                     <p className="mb-10">
//                       Taken possession of my entire soul, like these sweet
//                       mornings of spring which i enjoy with my whole.
//                     </p>
//                     <p className="">
//                       Taken possession of my entire soul, like these sweet
//                       mornings of spring which i enjoy with my whole.
//                     </p>
//                   </div>
//                 </div>

//                 <div className="item mb-15 wow fadeInUp" data-wow-delay=".3s">
//                   <div className="title">
//                     <h6>Talented, Professional & Expert Team</h6>
//                     <span className="ico ti-plus"></span>
//                   </div>
//                   <div className="accordion-info">
//                     <p className="">
//                       Taken possession of my entire soul, like these sweet
//                       mornings of spring which i enjoy with my whole.
//                     </p>
//                   </div>
//                 </div>

//                 <div className="item wow fadeInUp" data-wow-delay=".5s">
//                   <div className="title">
//                     <h6>We Build and Activate Brands</h6>
//                     <span className="ico ti-plus"></span>
//                   </div>
//                   <div className="accordion-info">
//                     <p className="">
//                       Taken possession of my entire soul, like these sweet
//                       mornings of spring which i enjoy with my whole.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="line-overlay up opacity-7">
//         <svg
//           viewBox="0 0 1728 1101"
//           fill="none"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path
//             d="M-43 773.821C160.86 662.526 451.312 637.01 610.111 733.104C768.91 829.197 932.595 1062.9 602.782 1098.75C272.969 1134.6 676.888 25.4306 1852 1"
//             style={{ strokeDasharray: 3246.53 }}
//           ></path>
//         </svg>
//       </div>
//     </section>
//   );
// }







// export default FAQS;

import React, { useState } from 'react';
import faqData from '../../../data/faqs.json';

const FAQS = () => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubQuestion, setActiveSubQuestion] = useState(null);

  const toggleCategory = (categoryId) => {
    setActiveCategory(activeCategory === categoryId ? null : categoryId);
    setActiveSubQuestion(null);
  };

  const toggleSubQuestion = (subQuestionId) => {
    setActiveSubQuestion(activeSubQuestion === subQuestionId ? null : subQuestionId);
  };

  return (
    <section className="faqs section-padding position-re">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-4">
            <div className="sec-head md-mb80">
              <h6 className="sub-title main-color mb-15">FAQS</h6>
              <h2>
                Frequently <br /> asked questions
              </h2>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="list-serv">
              <div className="accordion bord">
                {faqData.serviceCategories.map((category) => (
                  <div key={category.id} className="category-container mb-15">
                    <div 
                      className={`item wow fadeInUp ${activeCategory === category.id ? 'active' : ''}`}
                      onClick={() => toggleCategory(category.id)}
                    >
                      <div className="title">
                        <h6>{category.title}</h6>
                        <span className={`ico ${activeCategory === category.id ? 'ti-minus' : 'ti-plus'}`}></span>
                      </div>
                      {activeCategory === category.id && (
                        <div className="sub-questions">
                          {category.subQuestions.map((subQ) => (
                            <div 
                              key={subQ.id} 
                              className={`sub-item ${activeSubQuestion === subQ.id ? 'active' : ''}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleSubQuestion(subQ.id);
                              }}
                            >
                              <div className="sub-title">
                                <h6>{subQ.question}</h6>
                                <span className={`ico ${activeSubQuestion === subQ.id ? 'ti-minus' : 'ti-plus'}`}></span>
                              </div>
                              {activeSubQuestion === subQ.id && (
                                <div className="accordion-info">
                                  <p>{subQ.answer}</p>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="line-overlay up opacity-7">
        <svg viewBox="0 0 1728 1101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M-43 773.821C160.86 662.526 451.312 637.01 610.111 733.104C768.91 829.197 932.595 1062.9 602.782 1098.75C272.969 1134.6 676.888 25.4306 1852 1" 
                style={{ strokeDasharray: '3246.53' }}></path>
        </svg>
      </div>

      <style jsx>{`
        .sub-questions {
          padding-left: 20px;
          margin-top: 10px;
        }
        .sub-item {
          margin: 10px 0;
          padding: 15px;
          border-radius: 5px;
          background-color: rgba(255, 255, 255, 0.02);
          cursor: pointer;
        }
        .sub-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .sub-title h6 {
          margin: 0;
          font-size: 0.9em;
        }
        .accordion-info {
          padding: 15px 0 0;
        }
      `}</style>
    </section>
  );
};

export default FAQS;